import { render, staticRenderFns } from "./ElectronicTemplateConfig.vue?vue&type=template&id=7004dac4&scoped=true"
import script from "./ElectronicTemplateConfig.vue?vue&type=script&lang=js"
export * from "./ElectronicTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./ElectronicTemplateConfig.vue?vue&type=style&index=0&id=7004dac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004dac4",
  null
  
)

export default component.exports